
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"12","height":"10"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h11.427v9.363H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"fill":"#6D7587","d":"M4.711 9.128a.829.829 0 00.21-.568.837.837 0 00-.21-.572l-2.236-2.5h8.226a.81.81 0 00.001-1.613H2.474l2.243-2.5a.86.86 0 00.21-.572.845.845 0 00-.21-.568.673.673 0 00-1.022 0L.196 4.14a.857.857 0 00-.007 1.083l.076.084L3.688 9.13a.676.676 0 001.023-.002","mask":"url(#b)"}})])])
          )
        }
      }
    